import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSleutels = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="m12.485 33.799 5.899-5.898a6.002 6.002 0 0 0 6.83-9.658 6 6 0 0 0-9.659 6.83l-8.727 8.726 4.243 4.243 2.829-2.829z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M22.385 23.9a2 2 0 1 1-2.829-2.83 2 2 0 0 1 2.829 2.83"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="m23.692 8.746 11.597 4.221-2.052 5.638-3.76-1.368.685-1.88-7.838-2.852a6 6 0 1 1 1.368-3.759"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M17.006 10.57a2 2 0 1 0 1.368-3.759 2 2 0 0 0-1.368 3.759"
    />
    <path
      fill="#00215B"
      d="m15.354 32.647-.708.707L12.293 31l4.353-4.353.707.707L13.708 31zM24 11a6 6 0 1 1-6-6v1a5 5 0 1 0 5 5z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSleutels);

export default ForwardRef;
